import Vue from 'vue';
import Router from 'vue-router';
import DashboardLayout from '@/layout/DashboardLayout.vue';
import AuthLayout from '@/layout/AuthLayout.vue';
import store from '@/store';

Vue.use(Router);

function requiresLogin(to, from, next) {
  if (store.getters.isLoggedIn
      || (window.localStorage.getItem('northswing-token') !== null
      && window.localStorage.getItem('northswing-user') !== null)
  ) {
    next();
  } else {
    next('/login');
  }
}

export default new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'leagues',
      component: DashboardLayout,
      beforeEnter: requiresLogin,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),
        },
        {
          path: '/leagues',
          name: 'leagues',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/Leagues.vue'),
        },
        {
          path: '/leagues/new',
          name: 'new league',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/AddLeague.vue'),
        },
        {
          path: '/leagues/:id/edit',
          name: 'edit league',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/AddLeague.vue'),
          props: true,
        },
        {
          path: '/leagues/:id/scores',
          name: 'add league scores',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/AddLeagueScores.vue'),
          props: true,
        },
        {
          path: '/leagues/:id/week/:week/schedule',
          name: 'edit week schedule',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/LeagueScheduleBuilder.vue'),
          props: true,
        },
        {
          path: '/leagues/:id',
          name: 'view league',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leagues/ViewLeague.vue'),
          props: true,
        },
        {
          path: '/players',
          name: 'players',
          component: () => import(/* webpackChunkName: "demo" */ './views/Players/PlayerList.vue'),
        },
        {
          path: '/players/new',
          name: 'add player',
          component: () => import(/* webpackChunkName: "demo" */ './views/Players/CreateEditPlayer.vue'),
        },
        {
          path: '/players/:id/edit',
          name: 'edit player',
          component: () => import(/* webpackChunkName: "demo" */ './views/Players/CreateEditPlayer.vue'),
          props: true,
        },
        {
          path: '/teams',
          name: 'teams',
          component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue'),
        },
        {
          path: '/courses',
          name: 'courses',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue'),
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue'),
        },
        {
          path: '/live',
          name: 'view live games',
          component: () => import(/* webpackChunkName: "demo" */ './views/LiveGames/LiveGamesList.vue'),
        },
        {
          path: '/live/:id',
          name: 'view live game',
          component: () => import(/* webpackChunkName: "demo" */ './views/LiveGames/ViewLiveGame.vue'),
          props: true,
        },
      ],
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue'),
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue'),
        },
      ],
    },
  ],
});
